module.exports = __webpack_public_path__ + "static/img/offline.dfd2d26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/m/offline.png
// module id = C297
// module chunks = 23